import { render, staticRenderFns } from "./contactWay.vue?vue&type=template&id=0bba60b1&scoped=true&"
import script from "./contactWay.vue?vue&type=script&lang=js&"
export * from "./contactWay.vue?vue&type=script&lang=js&"
import style0 from "./contactWay.vue?vue&type=style&index=0&id=0bba60b1&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bba60b1",
  null
  
)

export default component.exports